import { toast } from 'react-toastify';

// Common Toast Options
const toastOptions = {
  position: 'top-right',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
};

export const showSuccessToast = (message = 'Operation successful!') => {
  const updatedOptions = {
    ...toastOptions,
    style: { '--toastify-color-progress-success': '#ff4d1c' },
  };
  toast.success(message, updatedOptions);
};

export const showErrorToast = (message = 'Something went wrong!') => {
  toast.error(message, toastOptions);
};

export const showInfoToast = (message = 'Info') => {
  toast.info(message, toastOptions);
};

export const showWarningToast = (message = 'Warning!') => {
  toast.warn(message, toastOptions);
};
